import { useStaticQuery, graphql } from 'gatsby'

export const useMenuItems = () =>
  useStaticQuery(graphql`
    query {
      globalHeaderEn: sanityGlobalHeader(i18n_lang: {eq: "en"}) {
        menu {
          items {
            title
            url
          }
        }
      }
      globalHeaderIt: sanityGlobalHeader(i18n_lang: {eq: "it"}) {
        menu {
          items {
            title
            url
          }
        }
      }
    }
  `)